var map = {
	"./hotspot/scene1/Active_Low_Frequency_Towed_Sonar_01.jpg": 40,
	"./hotspot/scene1/Active_Low_Frequency_Towed_Sonar_02.jpg": 41,
	"./hotspot/scene1/Gun_Bay_01.jpg": 42,
	"./hotspot/scene1/Gun_Bay_02.jpg": 43,
	"./hotspot/scene1/Machinery_Control_Room_01.jpg": 44,
	"./hotspot/scene1/Medical_Centre_01.jpg": 45,
	"./hotspot/scene2/Hangar_Door_01.jpg": 46,
	"./hotspot/scene2/Hangar_Door_02.jpg": 47,
	"./hotspot/scene2/Helicopter_Control_Room_01.jpg": 48,
	"./hotspot/scene2/Helicopter_Control_Room_02.jpg": 49,
	"./hotspot/scene2/Helicopter_Landing_Aids_01.jpg": 50,
	"./hotspot/scene2/Rapid_Securing_Device_01.jpg": 51,
	"./hotspot/scene2/S-70B_Seahawk_Naval_Helicopter_01.jpg": 52,
	"./hotspot/scene3/Harpoon_Missile_01.jpg": 53,
	"./hotspot/scene3/Launch_and_Recovery_System_01.jpg": 54,
	"./hotspot/scene3/Rigid_Hull_Boat_01.jpg": 55,
	"./hotspot/scene3/Whitehead_Torpedo_01.jpg": 56,
	"./hotspot/scene4/76mm_Oto_Melara_Super_Rapid_Gun_01.jpg": 57,
	"./hotspot/scene4/76mm_Oto_Melara_Super_Rapid_Gun_01.mp4": 58,
	"./hotspot/scene4/Aster_Missile_01.jpg": 59,
	"./hotspot/scene4/Bridge_Engineering_Large_Screen_01.jpg": 60,
	"./hotspot/scene4/Electronic_Chart_Display_and_Information_System_01.jpg": 61,
	"./hotspot/scene4/Integrated_Bridge_Consoles_01.jpg": 62,
	"./hotspot/scene4/Portable_Bridge_Station_01.jpg": 63,
	"./hotspot/scene4/Typhoon_MK_II_25mm_Stabilised_Naval_Gun_Systems_01.jpg": 64,
	"./hotspot/scene4/Typhoon_MK_II_25mm_Stabilised_Naval_Gun_Systems_01.mp4": 65,
	"./hotspot/scene5/Command_Cluster_01.jpg": 66,
	"./hotspot/scene5/Command_Management_System_01.jpg": 67,
	"./hotspot/scene5/Picture_Cluster_01.jpg": 68,
	"./hotspot/scene5/Strike_defence_Cluster_01.jpg": 69,
	"./icons/lookaround.png": 12,
	"./icons/mission.png": 70,
	"./icons/navi/i.png": 71,
	"./icons/navi/logo.png": 13,
	"./icons/navi/search.png": 72,
	"./icons/orientation.png": 14,
	"./icons/ship.png": 15,
	"./icons/social/facebook.png": 73,
	"./icons/social/instagram.png": 74,
	"./icons/social/mail.png": 75,
	"./icons/social/whatsapp.png": 76,
	"./icons/social/youtube.png": 77,
	"./icons/stories.png": 78,
	"./ss/1.jpg": 79,
	"./ss/2.jpg": 80,
	"./ss/3.jpg": 81,
	"./ss/4.jpg": 82,
	"./ss/5.jpg": 83,
	"./ss/mobile/1.jpg": 84,
	"./ss/mobile/2.jpg": 85,
	"./ss/mobile/3.jpg": 86,
	"./ss/mobile/4.jpg": 87,
	"./ss/mobile/5.jpg": 88,
	"./thumbs/lmv.jpg": 89,
	"./thumbs/mission.jpg": 90,
	"./thumbs/stories.jpg": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;